'use client'
import React from 'react';
import { Autocomplete, Paper, Grid, TextField, Typography, Box, Stack, Divider, Card, CardContent, CardHeader, Button, Fade, Switch, FormControlLabel } from "@mui/material";
import TrapFocus from '@mui/material/Unstable_TrapFocus';



interface LegalTermsProps {
    bannerOpen: boolean;
    setBannerOpen: (open: boolean) => void;
    setBannerClosed: (closed: boolean) => void;
}

const LegalTerms: React.FC<LegalTermsProps> = (props) => {
    const closeBanner = () => {
        props.setBannerClosed(false);
    }

    return (
        <TrapFocus open disableAutoFocus disableEnforceFocus>
            <Fade appear={false} in={props.bannerOpen}>
                <Paper
                    role="dialog"
                    aria-modal="false"
                    aria-label="Cookie banner"
                    square
                    variant="outlined"
                    tabIndex={-1}
                    sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    m: 0,
                    p: 2,
                    borderWidth: 0,
                    borderTopWidth: 1,
                    zIndex: 1
                    }}
                >
                    <Box
                        sx={{
                        flexShrink: 1,
                        alignSelf: { xs: 'flex-start', sm: 'center' },
                        }}>
                        
                        <Stack spacing={2}>
                            <Typography fontWeight="bold">Accept Legal Terms</Typography>
                            <Typography variant="body2">
                            By using this VCO site, I represent, acknowledge, and agree that I am either (a) at least 18 years old, 
                            or (b) at least 13 years old and using this site with the consent of my parent or legal guardian. I further acknowledge that if I am not at least 13 years old, 
                            that I may not use this site at any time or in any manner or submit any information herein. 
                            I consent to receiving cash-out through the issuance of a check or an electronic funds transfer through this virtual customer service desk. I consent to the 
                            collection of my personal information for the purpose of receiving cash-out and consent to the processing of my personal information in the United States 
                            for that purpose.
                            </Typography>
                            <Typography variant="body2">
                            By clicking below, I confirm that I am the cardholder of the gift card specified above; 
                            and I request cash-out the gift card via this online process and verify that the information completed by me above is accurate and that I am the appropriate age to 
                            use this site.
                            </Typography>
                            <Button 
                                sx={{ maxWidth: 250 }} 
                                type="button" 
                                size="small" 
                                onClick={closeBanner} 
                                variant="contained" 
                                color="primary">
                                Accept Terms
                            </Button>
                        </Stack>
                    </Box>
                </Paper>
            </Fade>
        </TrapFocus>
    );
};

export default LegalTerms;